<template>
  <div class="b-app-standard-snackbar" v-if="show">
    <div class="b-app-standard-snackbar__box" @click="onClickNotification()">
      <div style="display:flex">
        <div>
          <span v-if="$store.state.kycLogin.succesFlag">
            <img src="../../assets/success.png" style="width: 18px" />
          </span>
          <span v-else>
            <img src="../../assets/reject.png" style="width: 18px" />
          </span>
        </div>
        <div class="b-app-standard-snackbar__box-text">{{ text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    };
  },

  props: {
    value: {
      default() {
        return false;
      }
    },
    text: {
      default() {
        return "notification text here...";
      }
    },
    timeout: {
      default() {
        return 3000;
      }
    }
  },

  methods: {
    onClickNotification() {
      this.$emit("onClickNotification");
    }
  },

  watch: {
    value: {
      handler(newValue, oldValue) {
        this.show = newValue;

        if (newValue)
          setTimeout(() => this.$emit("input", oldValue), this.timeout);
      },
      immediate: true
    }
  }
};
</script>
<style scoped lang="scss">
.b-app-standard-snackbar {
  @media screen and (max-width: 767px) {
    // m
    padding: {
      left: 40px;
      right: 40px;
    }

    display: flex;
    flex: {
      direction: row;
      wrap: nowrap;
    }
    align-items: flex-start;
    justify-content: center;
  }

  .b-app-standard-snackbar__box {
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    background-color: #ffffff;
    position: fixed;
    cursor: pointer;
    z-index: 3;
    @media screen and (max-width: 767px) {
      // m
      padding: {
        top: 11px;
        bottom: 12px;
        left: 16px;
        right: 16px;
      }
      width: 100%;
      max-width: 324px;
      bottom: 75px;
    }
    @media screen and (max-width: 320px) {
      // iphone 5
      width: 280px;
    }
    @media screen and (min-width: 768px) {
      // d
      padding: {
        top: 15px;
        bottom: 16px;
        left: 16px;
        right: 16px;
      }

      top: 2px;
      right: 44%;
    }

    .b-app-standard-snackbar__box-text {
      padding-left: 5px;
    }
  }
}
</style>